import CustomElement from "./CustomElement";

/** Product grid inside a collection or search section */
const GRID_SELECTOR = ".collection-grid > .grid, .search-results > .grid";

/**
 * Pagination
 * @augments CustomElement
 * @property {Function} bindLoadMore
 * @property {Function} loadData
 * @property {Function} renderGridWithPagination
 */
export default class Pagination extends CustomElement {

	constructor(){

		super();

		/**
		 * @member {string} section the shopify section this element binds to
		 * @member {string} type the type of pagination
		 */
		this.section = this.dataset.section;
		this.type = this.dataset.type;
		this.loading = false;

		if(this.type == "load-more" || this.type == "infinite") this.bindLoadMore();
	}

	/**
	 * Resolve the grid at call time, filtering may have re-rendered it
	 * @returns {HTMLElement|null}
	 */
	get grid() {

		return document.getElementById(`shopify-section-${this.section}`)?.querySelector(GRID_SELECTOR);
	}

	/**
	 * Only fire this for "infinite" type
	 * @returns
	 */
	onViewportEnter() {

		if(this.type !== "infinite") return;

		this.loadData();
	}

	/**
	 *
	 */
	bindLoadMore() {

		/**
		 * @memberof! Pagination
		 */
		this.button = this.querySelector("a");
		this.button?.addEventListener("click", (event) => {

			event.preventDefault();
			event.stopPropagation();

			this.loadData();
		});
	}

	/**
	 *
	 */
	loadData() {

		if(this.loading || !this.button) return;

		const url = new URL(this.button.href, window.location.origin);
		url.searchParams.set("section_id", this.section);

		this.loading = true;

		fetch(url)
			.then((response) => {

				if(!response.ok){

					let error = new Error(response.status);

					throw error;
				}

				return response.text();
			})
			.then((text) => {

				this.renderGridWithPagination(text);
			})
			.catch((error) => {

				console.error(error);
			})
			.finally(() => {

				this.loading = false;
			});
	}

	/**
	 *
	 * @param {string} html
	 * @returns
	 */
	renderGridWithPagination(html) {

		const dom = new DOMParser().parseFromString(html, "text/html");
		const grid = this.grid;
		const nextGrid = dom.querySelector(GRID_SELECTOR);

		/** Update grid with items */
		if(grid && nextGrid) {

			grid.append(...nextGrid.children);

			/** Load any images */
			window.Zero.lazyLoad.update();
		}

		/** Update pagination */
		let pagination = dom.querySelector("paginate-grid");

		/** Self destroy */
		if(!pagination?.querySelector("a")) {

			this.remove();

			return;
		}

		this.innerHTML = pagination.innerHTML;
		this.bindLoadMore();
	}
}
